import { StandardPanel } from "../../../_components/panel/standard.panel";
import type { AnnualCatalogueItemRow, BasketHistoryEntry } from "./auction-annual-shared";
import { AuctionAnnualBasketHistoryList } from "./auction-annual-basket-history-list";

interface AuctionAnnualCustomerBasketPanelProps {
    loading: boolean;
    history: BasketHistoryEntry[];
    catalogueItemsById: Map<number, AnnualCatalogueItemRow>;
}

export function AuctionAnnualCustomerBasketPanel({
    loading,
    history,
    catalogueItemsById,
}: AuctionAnnualCustomerBasketPanelProps) {
    return (
        <StandardPanel title="My Basket by Round" loading={loading} height="320px">
            <AuctionAnnualBasketHistoryList history={history} catalogueItemsById={catalogueItemsById} />
        </StandardPanel>
    );
}
